/**
 * @returns timestamp in a format expected by the remote API or `undefined` for invalid dates.
 */
export function dateToRemoteTimestamp(date: Date): string | undefined {
	if (Number.isNaN(date.getTime())) {
		return undefined;
	}

	// Construct ISO string in local time (without "Z" at the end to indicate it's not UTC)
	// We cannot use date.toISOString(), because it always returns UTC time without time saving adjustments.
	const year = date.getFullYear();
	const month = String(date.getMonth() + 1).padStart(2, '0'); // Months are zero-based
	const day = String(date.getDate()).padStart(2, '0');
	const hours = String(date.getHours()).padStart(2, '0');
	const minutes = String(date.getMinutes()).padStart(2, '0');
	const seconds = String(date.getSeconds()).padStart(2, '0');
	const milliseconds = String(date.getMilliseconds()).padStart(3, '0');

	return `${year}-${month}-${day}T${hours}:${minutes}:${seconds}.${milliseconds}`;
}
const COEFFICIENT = 1000 * 60; // milliseconds in 1 minute

export function roundedTimestamp() {
	return (Math.floor(Date.now() / COEFFICIENT) * COEFFICIENT) / 1000;
}
